export default "__VITE_ASSET__45d7ee53__"